import axios from "axios";
import authHeader from "./auth-header";
import dotenv from 'dotenv';

dotenv.config();

//const s = process.env.REACT_APP_API + ":" + process.env.PORT_API + "/api/test/";
const s = process.env.REACT_APP_API + "/api/test/";
const API_URL = s.replace(/'/g, "");

//const API_URL = "http://xtal.asia:4051/api/test/";
console.log(API_URL)

class UserService {
  getPublicContent() {
    return axios.get(API_URL + "all");
  }

  getUserBoard() {
    return axios.get(API_URL + "user", { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + "mod", { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + "admin", { headers: authHeader() });
  }
}

export default new UserService();
